import { Box, Rating, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { Product } from '../../interfaces/Product/Product';
import { ProductReview } from '../../interfaces/Product/ProductReview';
import { sharedColors } from '../../utils/Style';
import { useLocalizedText } from '../../hooks/useLocalizedText';

type ProductReviewSummaryProps = {
  product: Product;
  reviews?: ProductReview;
  onClick?: () => void;
};

export const ProductReviewSummary = ({
  product,
  reviews,
  onClick,
}: ProductReviewSummaryProps) => {
  const t = useLocalizedText();

  const labelStyle = {
    fontSize: '12px',
    color: sharedColors.gray6,
    textWrap: 'nowrap',
  };

  const highlightStyle = {
    fontSize: '12px',
    fontWeight: 600,
    color: sharedColors.gray7,
  };

  const content: ReactNode[] = [
    <Typography sx={labelStyle}>
      <Typography component='span' sx={highlightStyle}>
        {product.viewed}
      </Typography>{' '}
      {t('product.views')}
    </Typography>,
  ];
  if (reviews?.totalCount) {
    content.push(
      <Typography sx={labelStyle}>
        <Typography component='span' sx={highlightStyle}>
          {reviews.totalCount}
        </Typography>{' '}
        {t('product.review')}
      </Typography>,
    );
  }
  if (reviews?.avgRating) {
    content.push(
      <Box
        onClick={onClick}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 0.5,
          alignItems: 'center',
          cursor: 'pointer',
          '&:hover .rating-text': {
            textDecoration: 'underline',
          },
        }}
      >
        <Typography
          className='rating-text'
          sx={{ ...highlightStyle, fontSize: '16px' }}
        >
          {reviews.avgRating.toFixed(1)}
        </Typography>

        <Rating size='small' readOnly value={reviews.avgRating} />
      </Box>,
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 0.5,
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      {content.map((item, i) => (
        <>
          {item}
          {i < content.length - 1 && (
            <Typography sx={{ mt: 0.25 }}> • </Typography>
          )}
        </>
      ))}
    </Box>
  );
};
